import { t } from './i18n';
import { store } from '../app/store';
import { APP_CONFIG } from '../config/app';

export function openAboutModal(): void {
  const container = document.getElementById('modal-container');
  const card = document.getElementById('modal-card');
  if (!container || !card) return;

  const lang = store.getState().language;

  card.innerHTML = `
    <div class="modal-header">
      <h3 class="modal-title">${t('about_title', lang)}</h3>
      <button class="modal-close-btn" id="modal-close-btn" aria-label="Close">&times;</button>
    </div>
    <div class="about-content" style="font-size: 0.875rem; line-height: 1.6; display: flex; flex-direction: column; gap: 0.85rem;">
      <p style="color: #e2e8f0; font-weight: 500;">${t('about_stylized_notice', lang)}</p>
      <p style="color: #94a3b8;">${t('about_respect', lang)}</p>
      <p style="color: #94a3b8;">${t('about_zero_cost', lang)}</p>

      <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); padding: 0.75rem 1rem; border-radius: 12px; margin-top: 0.5rem;">
        <h4 style="color: var(--accent-gold); margin-bottom: 0.4rem; font-size: 0.9rem;">${t('about_credits_heading', lang)}</h4>
        <p style="color: #cbd5e1; font-size: 0.8rem;">${t('about_code_music', lang)}</p>
      </div>

      <div style="border-top: 1px solid rgba(255,255,255,0.1); padding-top: 0.75rem; font-size: 0.775rem; color: #64748b;">
        <p>${t('about_takedown', lang)}</p>
        <p style="margin-top: 0.25rem;">Contact maintainer: <a href="mailto:${APP_CONFIG.contactEmail}" style="color: var(--accent-blue);">${APP_CONFIG.contactEmail}</a></p>
      </div>
    </div>
  `;

  container.classList.remove('hidden');

  const closeBtn = document.getElementById('modal-close-btn');
  const backdrop = document.getElementById('modal-backdrop');

  const closeModal = () => {
    container.classList.add('hidden');
  };

  closeBtn?.addEventListener('click', closeModal, { once: true });
  backdrop?.addEventListener('click', closeModal, { once: true });
}
